export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8914.d8c2280f.jpg";